import styled, { css } from "styled-components/native";
import {
  Feather as IconsFE,
  FontAwesome5 as IconsFA5,
} from "@expo/vector-icons";
import { themes } from "../../design/colors";

export const Container = styled.View`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: ${themes.colors.primary};
  border-bottom-left-radius: 24px;
  border-bottom-right-radius: 24px;
  padding: 16px 20px 18px 20px;
  shadow-color: ${themes.colors.black};
  shadow-opacity: 0.15;
  shadow-radius: 12px;
  shadow-offset: 0px 4px;
  elevation: 6;
`;

export const HeaderInfos = styled.View`
  flex: 1;
  margin-left: 15px;
`;

export const TextWelcome = styled.Text`
  color: ${themes.colors.blue0};
  font-size: 12px;
`;

export const TitlePage = styled.Text`
  flex: 1;
  text-align: center;
  color: ${themes.colors.white};
  font-size: 16px;
  font-weight: bold;
`;

export const NameUser = styled.Text`
  color: ${themes.colors.white};
  font-size: 22px;
  font-weight: bold;
  line-height: 35px;
`;

// Alvo de toque circular e translúcido para os ícones de ação (voltar/sair),
// pra não deixar o ícone "boiando" solto sobre o fundo colorido.
export const IconButton = styled.TouchableOpacity`
  width: 40px;
  height: 40px;
  border-radius: 20px;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.16);
`;

export const AvatarRing = styled.View`
  border-radius: 999px;
  padding: 2px;
  border-width: 2px;
  border-color: rgba(255, 255, 255, 0.5);
`;

export const IconFE = styled(IconsFE)``;
